import { createSelector } from 'reselect'
import { RootState } from '../store'
import { IWaterSystem } from '../../types'
import { WaterSystemType } from './waterSystems.slice'

export const selectWaterSystemsLoading = (state: RootState) => state.waterSystems.loading
export const selectWaterSystemsError = (state: RootState) => state.waterSystems.error
export const selectWaterSystemsSuccess = (state: RootState) => state.waterSystems.success
export const userSearched = (state: RootState) => state.waterSystems.userSearched

export const selectSelectedWaterSystem = (state: RootState) =>
  state.waterSystems.selectedWaterSystem

export const selectSelectedWaterSystemType = (state: RootState) =>
  state.waterSystems.selectedSystemType as WaterSystemType

const selectWaterSystems = createSelector(
  [(state: RootState) => state.waterSystems.data?.waterSystems],
  (waterSystems) => waterSystems ?? []
);

const makeWaterSystems = createSelector(
  [selectWaterSystems],
  (data) => {
    if (!data.length) return [];
    
    return data.map(system => ({
      ...system,
      totalPopulation: system.POPULATION_SERVED_COUNT,
      totalConnections: system.SERVICE_CONNECTIONS_COUNT,
      totalViolations: system.VIOLATIONS_COUNT,
    }));
  }
);

const makeWaterSystemsSort = createSelector(
  [makeWaterSystems, (_, inputZipCode) => inputZipCode],
  (data, inputZipCode) => {
    return [...data].sort((a, b) => {
      const aMatches = a.ZIP_CODE === inputZipCode
      const bMatches = b.ZIP_CODE === inputZipCode

      if (aMatches && !bMatches) return -1
      if (!aMatches && bMatches) return 1

      if (aMatches && bMatches) {
        return a.PWSID.localeCompare(b.PWSID)
      }

      const zipComparison = a.ZIP_CODE!.localeCompare(b.ZIP_CODE!)
      if (zipComparison === 0) {
        return a.PWSID.localeCompare(b.PWSID)
      }
      return zipComparison
    })
  }
)

export const selectWaterSystemsIdsAndAddresses = createSelector(
  [selectWaterSystems],
  (data) => {
    if (!data.length) return [];
    
    return data.map((system: IWaterSystem) => ({
      id: system._id,
      address: system.ADDRESS_LINE1,
    }));
  }
)

const isLoading = (state: RootState) => state.waterSystems.loading

export const WaterSystemsSelector = {
  makeWaterSystems,
  makeWaterSystemsSort,
  selectWaterSystemsLoading,
  selectWaterSystemsError,
  selectWaterSystemsSuccess,
  selectSelectedWaterSystem,
  selectSelectedWaterSystemType,
  selectWaterSystemsIdsAndAddresses,
  userSearched,
  isLoading
}
